export const isMockMode = () => import.meta.env.VITE_USE_MOCKS === 'true';
